import { Stack } from "@mui/material";
import TextFieldControl, { TextFieldControlProps } from "components/form/TextFieldControl";
import VALIDATION from "helpers/validation";

interface InfoFormProps {
  isEditable: boolean;
}

const InfoForm = ({ isEditable }: InfoFormProps) => {
  const commonFieldProps: Partial<TextFieldControlProps> = {
    disabled: !isEditable,
    disabledViewAsText: true,
    rules: { required: true, ...VALIDATION.competencyMapTitle },
    InputProps: {
      sx: {
        fontSize: 18,
        fontWeight: !isEditable ? 500 : 400,
        "& input": { px: 1, py: 0.5 },
      },
    },
    labelTypographyProps: { sx: { fontSize: 18 } },
    horizontalMode: true,
  };

  return (
    <Stack
      spacing={1}
      sx={{ width: "100%" }}>
      <TextFieldControl
        label='Карта компетенций'
        name='title'
        {...commonFieldProps}
      />
      <TextFieldControl
        label='Специализация'
        name='specialization'
        {...commonFieldProps}
      />
    </Stack>
  );
};

export default InfoForm;
